import React from 'react';
import Skeleton from 'react-loading-skeleton';
import itemsStore from '../../store/itemsStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { TCategoryProduct } from 'src/types/categories';
import { getTranslate } from 'src/utils/helpers';
import Icon from 'src/view/components/Controls/Icon/Icon';
import '../../containers/ItemsCrossSelling/style.scss';

interface IProps {
  item?: TCategoryProduct;
}

const ItemCrossSellingItem: React.FC<IProps> = (props: IProps): JSX.Element => {
  const clickDelete = () => {
    if (!props.item) return;
    itemsStore.deleteCrossSellingItem(props.item.id);
  };

  return (
    <li className={`items-cross-selling__item mt-2 mr-2 ${props.item ? 'pl-3' : ''}`}>
      {props.item ? (
        <>
          <p className="family-medium text-size-18 color-dark text-elipsis">{getTranslate(props.item.name)}</p>
          <button onClick={clickDelete} className="items-cross-selling__btn-delete py-2 px-3">
            <Icon name={Icons.Close} size={12} color={theme.colors.gray3} />
          </button>
        </>
      ) : (
        <Skeleton width={145} height={40} style={{ borderRadius: 10 }} />
      )}
    </li>
  );
};

export default ItemCrossSellingItem;
